/**
 * WeddingContext — Exposes current wedding status to all dashboard pages
 * Used to enforce read-only mode when the wedding is cancelled.
 */
import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import weddingService from '@services/weddingService';
import { useAuth } from '@hooks/useAuth';

const WeddingContext = createContext(null);

export const WeddingProvider = ({ children }) => {
  const { user } = useAuth();
  const [wedding, setWedding] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadWedding = useCallback(async () => {
    if (!user) { setWedding(null); setLoading(false); return; }
    try {
      const r = await weddingService.getMyWedding();
      setWedding(r.data?.wedding || null);
    } catch {
      setWedding(null);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => { loadWedding(); }, [loadWedding]);

  const isCancelled = wedding?.status === 'cancelled';

  return (
    <WeddingContext.Provider value={{ wedding, isCancelled, loading, reload: loadWedding }}>
      {children}
    </WeddingContext.Provider>
  );
};

export const useWedding = () => {
  const ctx = useContext(WeddingContext);
  if (!ctx) return { wedding: null, isCancelled: false, loading: false, reload: () => {} };
  return ctx;
};

export default WeddingContext;
